<template>
  <div>
    <canvas :id="id"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'BarRadar',
  props: {
    data: {
      type: Object
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      labels: [],
      dataSet: [],
      borders: [],
      palette: [],
      colors: [
        '#a6cee3',
        '#1f78b4',
        '#b2df8a',
        '#33a02c',
        '#fb9a99',
        '#e31a1c',
        '#fdbf6f',
        '#ff7f00',
        '#cab2d6',
        '#6a3d9a',
        '#ffff99',
        '#b15928',
        '#8dd3c7',
        '#ffffb3',
        '#bebada',
        '#fb8072',
        '#80b1d3',
        '#fdb462',
        '#b3de69',
        '#fccde5',
        '#d9d9d9',
        '#bc80bd',
        '#ccebc5',
        '#ffed6f'
      ]
    }
  },
  mounted() {
    this.dataSet = [
      this.data.culture,
      this.data.leisure,
      this.data.education,
      this.data.retail,
      this.data.residential,
      this.data.hospitality,
      this.data.commercial
    ]
    this.createChart(this.id)
  },
  computed: {
    options() {
      return {
        aspectRatio: 1,
        responsive: true,
        legend: false,
        title: {
          display: false,
          text: 'Custom Chart Title'
        },
        spanGaps: true,
        scale: {
          angleLines: {
            display: false
          },
          ticks: {
            min: -1,
            max: 5
          }
        }
      }
    }
  },
  methods: {
    createChart(chartId) {
      const ctx = document.getElementById(chartId)
      new Chart(ctx, {
        type: 'radar',
        data: {
          labels: [
            'Culture',
            'Leisure',
            'Education',
            'Retail',
            'Residential',
            'Hospitality',
            'Commercial'
          ],
          datasets: [
            {
              data: this.dataSet,
              backgroundColor: 'rgba(255, 193, 7, 0.5)',
              borderColor: 'rgb(54, 162, 235)',
              pointBackgroundColor: 'rgb(54, 162, 235)',
              pointBorderColor: '#fff',
              borderWidth: 0,
              tension: 0.0,
              pointHoverBackgroundColor: '#fff',
              pointHoverBorderColor: 'rgb(54, 162, 235)'
            }
          ]
        },
        options: this.options
      })
    }
  }
}
</script>
